import { makeAutoObservable } from 'mobx'
import { logger } from 'shared/lib'
import { type IResponseImportNumbersStatus } from 'entities/Phone/api/types'
import { PhoneApi } from 'entities/Phone/api/phone'
import { type OrganizationStore } from 'entities/Organization/store/organization'

export class ImportNumbersStatusStore {
  private _importNumbersStatus: IResponseImportNumbersStatus | null = null
  private _isLoaded = false
  private _isLoading = false

  constructor(private _organizationStore?: OrganizationStore) {
    makeAutoObservable(this)
    this.fetchStatus()
  }

  fetchStatus = async () => {
    if (this._isLoading) return

    this._isLoading = true

    try {
      const { data } = await PhoneApi.getImportNumbersStatus()
      this._importNumbersStatus = data

      if (this._organizationStore && data.numbers_grace_period) {
        this._organizationStore.updateOrganizationNumbersGracePeriod(
          data.numbers_grace_period.is_active
        )
      }
    } catch (e) {
      logger.error(e)
    } finally {
      this._isLoaded = true
      this._isLoading = false
    }
  }

  get isLoaded() {
    return this._isLoaded
  }

  get isLoading() {
    return this._isLoading
  }

  get hasValidImportNumbersStatus() {
    return this._isLoaded && this._importNumbersStatus !== null
  }

  get importNumbersStatus() {
    return {
      availableNumbersLicenses: this._importNumbersStatus?.available_numbers_licenses,
      importedNumbersCount: this._importNumbersStatus?.imported_numbers_count,
      needsNumbersLicenses: this._importNumbersStatus?.needs_numbers_licenses,
      durationHours: this._importNumbersStatus?.numbers_grace_period?.duration_hours ?? 0,
      isActive: this._importNumbersStatus?.numbers_grace_period?.is_active ?? false,
      startedAt: this._importNumbersStatus?.numbers_grace_period?.started_at ?? '',
    }
  }

  dispose() {
    this._importNumbersStatus = null
    this._isLoaded = false
    this._isLoading = false
  }
}
